// import Vue from "vue";

export default {
  methods: {
    errorNotice(msg) {
      this.$Notice.error({ title: "Error", desc: msg, duration: 8 });
    },

    successNotice(msg) {
      this.$Notice.success({ title: "Success", desc: msg, duration: 8 });
    },

    errorMessage(msg) {
      this.$Message.error({ content: msg, duration: 4 });
    },

    successMessage(msg) {
      this.$Message.success({ content: msg, duration: 4 });
    },

    loadingSuccess(msg) {
      msg = msg || "Resource loaded";
      this.$Loading.finish();
      this.successNotice(msg);
    },

    loadingError(msg) {
      msg = msg || "Failed to load resource";
      this.$Loading.error();
      this.errorNotice(msg);
    },
  },
};
